/**
 * Status configuration map for insurance application statuses.
 * Each status has a Thai + English label, Ant Design Tag color, and antdStatus.
 *
 * Requirements: 3.2, 3.3
 */
export const STATUS_CONFIG = {
  waiting_for_payment: {
    label: "รอชำระเงิน (Waiting for Payment)",
    color: "orange",
    antdStatus: "warning",
  },
  pending: {
    label: "รอดำเนินการ (Pending)",
    color: "orange",
    antdStatus: "warning",
  },
  completed: {
    label: "สำเร็จ (Completed)",
    color: "green",
    antdStatus: "success",
  },
  rejected: {
    label: "ปฏิเสธ (Rejected)",
    color: "red",
    antdStatus: "error",
  },
};
